import type { GameMeta } from '@/contracts/game-module';

/**
 * Catalog of games — metadata only.
 * Do NOT import game UI modules here (keeps landing bundle light).
 */
export const GAME_CATALOG: readonly GameMeta[] = [
  {
    id: 'wordle',
    path: '/wordle',
    titleKey: 'gameWordleTitle',
    descriptionKey: 'gameWordleDescription',
    icon: '🔤',
    status: 'available',
  },
] as const;

export function getAvailableGames(): readonly GameMeta[] {
  return GAME_CATALOG.filter((g) => g.status === 'available');
}

export function getGameById(id: string): GameMeta | undefined {
  return GAME_CATALOG.find((g) => g.id === id);
}
